import { createOdysTheme } from '@odys/design-system/theme';

// Typo de l'app catalog : Poppins, taille de base 14px.
export const theme = createOdysTheme({ fontFamily: 'var(--font-poppins)', fontSize: 14 });
